import React from 'react';

import { useFulfillmentPlannerContext } from '../context';

import { PickupTime } from './index';

export const FulfillmentPlannerContextPickupTimeContainer = () => {
  const { estimatedPickup } = useFulfillmentPlannerContext();

  return <PickupTime emptyValue='--' pickupDateTime={estimatedPickup} />;
};
